import React from "react";
import logo from "../../Images/UniversityLogo.jpg";
import "./Information.css";

const Information = () => {
  return (
    <div className="row w-75 m-auto ">
      <div className="col-md-6 mt-5 pt-3">
        <h1 className="text-center about-title font">My Skills</h1>
        <li className="text-left mt-3 mb-2 skils">Programming Language :</li>
        <div className="row">
          {/* <p className="skills-btn">C</p> */}
          {/* <p className="skills-btn">C++</p> */}
          <p className="skills-btn">Java</p>
          <p className="skills-btn">JavaScript</p>
          {/* <p className="skills-btn">Python</p> */}
        </div>
        <li className="text-left mt-3 mb-2 skils">Comfortable :</li>
        <div className="row">
          <p className="skills-btn">HTML5</p>
          <p className="skills-btn">CSS3</p>
          <p className="skills-btn">Bootstrap</p>
          <p className="skills-btn">React</p>
          <p className="skills-btn">React Router</p>
          <p className="skills-btn">React Bootstrap</p>
          <p className="skills-btn">Material UI</p>
        </div>
        <li className="text-left mt-3 mb-2 skils">Familiar :</li>
        <div className="row">
          <p className="skills-btn">Next JS</p>
          <p className="skills-btn">Node JS</p>
          <p className="skills-btn">MongoDB</p>
          <p className="skills-btn">Express JS</p>
          <p className="skills-btn">Redux Toolkit</p>
          <p className="skills-btn">Socket io</p>
          <p className="skills-btn">Svelte</p>
          <p className="skills-btn">Svelte Kit</p>
        </div>
        {/* <li className="text-left mt-3 mb-2 skils">Extra Skills :</li>
        <div className="row">
          <p className="skills-btn">Adobe Photoshop</p>
          <p className="skills-btn">Machine Learning</p>
          <p className="skills-btn">Deep Learning Algorithm</p>
          <p className="skills-btn">Networking</p>
          <p className="skills-btn">Computer Architecture</p>
        </div> */}
        <li className="text-left mt-3 mb-2 skils">Tools :</li>
        <div className="row">
          <p className="skills-btn">VS Code</p>
          <p className="skills-btn">Code Blocks</p>
          <p className="skills-btn">Eclipse IDE</p>
          <p className="skills-btn">Git</p>
          <p className="skills-btn">Firebase</p>
          <p className="skills-btn">Chrome Dev Tools</p>
          <p className="skills-btn">Heroku</p>
          <p className="skills-btn">Netlify</p>
          {/* <p className="skills-btn">MS Office</p> */}
        </div>
      </div>
      <div className="col-md-6 col-sm-4 mt-5 pt-3">
        <div className="col-md-12">
          <h1 className="mb-4 text-center about-title font">
            Contact Information
          </h1>
          <div className="col">
            <h3 className="row mail">
              <i class="fas fa-envelope-open-text mInfo"> lukman.webdev@gmail.com</i>
            </h3>
            <br />
            <h3 className="row ">
              <i class="fas fa-mobile-alt"> +880 1712561239</i>
            </h3>
          </div>
        </div>
        <h1 className="text-center about-title font mt-5 mb-3">My Education</h1>
        <div className="education w-100 m-auto text-center">
          <h3 className="mb-4 mt-3 blog-title">Under Graduate Student</h3>
          <h4>B.Sc. in Computer Science & Engineering</h4>
          <div className="uni-logo">
            <img className="lg" style={{ width: "53px" }} src={logo} alt="" />
            <h5>Leading University, Sylhet</h5>
          </div>
          <h6>2020 - Current</h6>
        </div>
      </div>
    </div>
  );
};

export default Information;
